// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__1UUC1","options":"AnswerScale_options__1YCrd","selected":"AnswerScale_selected__2utHB"};